import { getCookieConsent } from './cookies.js';

export const trackEvent = (eventName, eventParams = {}) => {
  if (getCookieConsent('analytics')) {
    window.gtag('event', eventName, eventParams);
    // Also track in our database
    fetch('https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/track-event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eventType: eventName,
        eventId: eventParams.event_id,
        promoterId: eventParams.promoter_id,
        userId: eventParams.user_id,
        partnerId: eventParams.partner_id,
        clickType: eventParams.click_target
      })
    }).catch(error => console.error('Error tracking event:', error));
  }
};

export const EventTypes = {
  BANNER_CLICK: 'banner_click',
  EVENT_CLICK: 'event_click',
  PARTNER_CLICK: 'partner_click',
  ICAL_DOWNLOAD: 'ical_download'
}; 